export default __webpack_public_path__ + "static/media/hero-bg.598119e7.webp";